<template>
  <div class="sellerModalClosest">
    {{ sellerModalStatusInjected }}
  </div>
</template>

<script setup lang="ts">
const sellerModalStatusInjected = inject<Ref<string>>('sellerModalStatus');
</script>

<style scoped lang="scss">
.sellerModalClosest {
  font-family: Eczar;
  font-weight: 500;
  font-size: 20px;
  line-height: 1.1;
  color: var(--blue_highlight);
}
</style>
